import { render } from "./Cursor.vue?vue&type=template&id=f03f7d0a"
import script from "./Cursor.vue?vue&type=script&lang=js"
export * from "./Cursor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/twig/components/cursor/Cursor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f03f7d0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f03f7d0a', __exports__)) {
    api.reload('f03f7d0a', __exports__)
  }
  
  module.hot.accept("./Cursor.vue?vue&type=template&id=f03f7d0a", () => {
    api.rerender('f03f7d0a', render)
  })

}


export default __exports__